import './ExpertInfo.scss';
import { useGetExpertData } from '../../utils';

const ExpertInfo = () => {
  const { expertInfo, expertAvatar } = useGetExpertData();

  const renderValue = (val: any): string => {
    if (val === null || val === undefined) return '';

    if (Array.isArray(val)) {
      return val.map(item => renderValue(item)).filter(Boolean).join(', ');
    }

    if (typeof val === 'object') {
      const text = val.name || val.userName || val.title || val.label || '';
      return typeof text === 'object' ? renderValue(text) : String(text);
    }

    return String(val);
  };

  const name = renderValue(expertInfo?.userName);
  const profession = renderValue(expertInfo?.profession);

  const initials = (name || '?')
    .trim()
    .split(' ')
    .map(part => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  return (
    <div className='expertInfo'>
      <div className='avatarWrap'>
        {expertAvatar ? (
          <img src={`data:image/png;base64,${expertAvatar}`} alt='expert-avatar' className='avatar' />
        ) : (
          <span className='avatarInitials'>{initials}</span>
        )}
      </div>
      <div className='infoContent'>
        <h2>{name}</h2>
        {profession && <p className='title'>{profession}</p>}
      </div>
    </div>
  );
};

export default ExpertInfo